import { createIcon } from '@chakra-ui/react';

export const TemperatureWarningIcon = createIcon({
  displayName: 'TemperatureWarningIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    fill: 'none',
    height: '24',
    width: '24',
  },
  path: (
    <>
      <g>
        <path
          d="M12 2.25C13.7949 2.25 15.25 3.70507 15.25 5.5V13.4199C16.1581 14.3143 16.75 15.6682 16.75 17C16.75 19.6234 14.6234 21.75 12 21.75C9.37665 21.75 7.25 19.6234 7.25 17C7.25 15.6551 7.81412 14.3116 8.75 13.4141V5.5C8.75 3.70507 10.2051 2.25 12 2.25ZM12 3.75C11.0335 3.75 10.25 4.5335 10.25 5.5V14.1104L9.96875 14.335C9.24374 14.9162 8.75 15.9488 8.75 17C8.75 18.7949 10.2051 20.25 12 20.25C13.7949 20.25 15.25 18.7949 15.25 17C15.25 15.98 14.7333 14.9174 14.0215 14.3281L13.75 14.1025V5.5C13.75 4.5335 12.9665 3.75 12 3.75ZM12.75 15.1465C13.4828 15.4433 14 16.1608 14 17C14 18.1046 13.1046 19 12 19C10.8954 19 10 18.1046 10 17C10 16.1608 10.5172 15.4433 11.25 15.1465V7.25H12.75V15.1465Z"
          fill="#E67635"
        />
        <path
          d="M20 0C20.7776 0 21.5 0.578942 21.5 1.40039V8.59961C21.5 9.42106 20.7776 10 20 10C19.2224 10 18.5 9.42106 18.5 8.59961V1.40039C18.5 0.578942 19.2224 0 20 0Z"
          fill="#E67635"
          stroke="#FFEFE6"
          strokeLinecap="round"
        />
        <path
          d="M20 10C20.8284 10 21.5 10.6716 21.5 11.5C21.5 12.3284 20.8284 13 20 13C19.1716 13 18.5 12.3284 18.5 11.5C18.5 10.6716 19.1716 10 20 10Z"
          fill="#E67635"
          stroke="#FFEFE6"
        />
      </g>
    </>
  ),
});
